import {
  AlertTriangle,
  Award,
  BarChart3,
  Building2,
  Calendar,
  CalendarCheck,
  ClipboardCheck,
  Clock,
  Code2,
  Cpu,
  ChartNoAxesCombined,
  Database,
  FileText,
  Forklift,
  Globe,
  Handshake,
  Layers,
  ListOrdered,
  Lock,
  Megaphone,
  Monitor,
  Network,
  Package,
  RefreshCw,
  Server,
  Settings,
  ShieldCheck,
  Store,
  Truck,
  Unplug,
  UserRound,
  Users,
  Warehouse,
  Zap,
  Boxes,
  CircleDollarSign,
  ShoppingCart,
} from "lucide-react";

export const ICON_SIZE = {
  sm: 20,
  md: 24,
  lg: 28,
  xl: 32,
};

export const trustIconMap = {
  shield: ShieldCheck,
  ribbon: Award,
  lock: Lock,
};

export const painIconMap = {
  clock: Clock,
  sync: RefreshCw,
  thunderbolt: Zap,
  cluster: Network,
  disconnect: Unplug,
  bars: ListOrdered,
  memory: Cpu,
  database: Database,
  server: Server,
  shop: Store,
  schedule: Calendar,
  api: Code2,
};

export const deliverableIconMap = [
  Users,
  ClipboardCheck,
  ChartNoAxesCombined,
  FileText,
];

export const processIconMap = {
  calendar: Calendar,
  document: FileText,
  team: Users,
  chart: BarChart3,
  handshake: Handshake,
};

export const faqIconMap = {
  question: CircleDollarSign,
  code: Code2,
  sales: Megaphone,
  lock: Lock,
  alert: AlertTriangle,
  calendar: Calendar,
};

export const hubIconMap = [
  ShoppingCart, // eCommerce
  Store, // POS/Stores
  Warehouse, // WMS
  Building2, // ERP
  Forklift, // Distribution Centers
  Truck, // Carriers
  Package, // Inventory
  Globe, // Marketplace
  UserRound, // Customers
];

export const HubCenterIcon = Server;
export const ArchitectureIcon = Building2;
export const OperationalGearIcon = Settings;
export const CalendarCheckIcon = CalendarCheck;
export const AdvisorIcon = UserRound;
